import { CurrentSession } from '@shared/app/scripts/services/current-session';

export class UserSession {
  constructor(private currentSession: CurrentSession) {}

  userData = { tenants: [] };

  isPolytex = () => {
    return this.currentSession.tenantId === '90017';
  };

  setTenants = (tenants: any[]) => {
    this.userData.tenants = [];
    for (const c in tenants) {
      this.userData.tenants.push({
        name: tenants[c].name,
        id: tenants[c].id,
      });
    }
  };

  //send a json object, values will be appended
  set = (data: any) => {
    for (const i in data) {
      this.userData[i] = data[i];
    }
  };

  //Provide a key and get specified value back
  get = (key: string) => {
    return this.userData[key] ? this.userData[key] : null;
  };

  //Clear entire object
  clear = () => {
    this.userData = { tenants: [] };
  };
}

/**
 * @ngdoc service
 * @name v6CoreModule.userSession
 * @description
 * Service to store user data such as tenants, permissions, and user information
 */
angular
  .module('v6CoreModule')
  .service('userSession', (currentSession: CurrentSession) => {
    return new UserSession(currentSession);
  });
